import React from 'react';

import AcfComponents from '@jpp/organisms/AcfComponents/AcfComponents';
import ContactContent from '@jpp/organisms/ContactContent';
import { IPageTemplateProps } from 'common/typings/types';

const Contact: React.FunctionComponent<IPageTemplateProps> = ({ page }) => {
  const acf = page.acf || page.acf_fields;

  return (
    <>
      {acf && (
        <AcfComponents
          components={acf?.components}
          page_theme={acf?.page_theme}
        />
      )}
      <ContactContent />
    </>
  );
};

export default Contact;
